module.exports = __webpack_public_path__ + "img/ios_tip.63396bcf.png";